import { readFileAsText } from "../../../utils/utility";

export const fileAccept =
  ".csv, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";

export const documentTableColumns = ["Nombre del fichero", "Opciones", "Tamaño"];

export async function validateFile(doc: File): Promise<string[]> {
  const errors: string[] = [];

  // Validaciones: formato del fichero, tamaño, campos
  try {
    if (doc.size > 2048000) {
      return ["El tamaño del fichero excede el máximo tamaño permitido de 2MB."];
    }

    const fileExtension = doc.name.split(".").pop();
    if (fileExtension !== "csv") {
      errors.push("La extensión del archivo es errónea");
    }

    const text = await readFileAsText(doc);

    if (typeof text !== "string") {
      errors.push("Formato del archivo no válido.");
      return errors;
    }

    if (text.trim().length <= 0) {
      errors.push("Archivo vacío");
      return errors;
    }

    const rows = text.split(/\r?\n|\r/);
    const columns = rows[0].split(";");

    if (columns.length !== 3) {
      errors.push("Número de columnas del fichero no válida.");
    }

    if (columns[0].toUpperCase() !== "USUARIO" || columns[2].toUpperCase() !== "ESTADO") {
      errors.push("Campos del archivo erróneos.");
    }

    return errors;
  } catch (err) {
    return ["Archivo no válido"];
  }
}
